<template>
    <!-- 拍品筛选 -->
    <div class="page box">
        <!-- 导航栏 -->
        <van-nav-bar title="拍品筛选" left-arrow @click-left="onClickLeft">
            <template #right>
                <!-- <van-icon name="search" size="18" /> -->
            </template>
        </van-nav-bar>

        <!-- 拍卖状态 -->
        <div class="pin_state">
            <div class="state_title">拍卖状态</div>
            <div class="list_contain">
                <div
                    ref="statusDom"
                    @click="statuClick(index)"
                    class="one"
                    :class="{'statuss':$route.query.params.status == item.id}"
                    v-for="(item, index) in searchStatusDatas"
                    :key="index"
                >
                    <div class="one_item">{{ item.text }}</div>
                </div>
            </div>
        </div>
        <!-- 拍卖时间 -->
        <div class="pin_time">
            <div class="time_title">拍卖时间</div>
            <div class="list_contain">
                <div class="option-time">
                    <div class="start-time" @click="startdatatime">
                        {{ startTitle }}
                    </div>
                    <span>—</span>
                    <div class="end-time" @click="enddatatime">
                        {{ endTitle }}
                    </div>
                </div>
            </div>
        </div>
        <!-- 估价（原币种） -->
        <div class="pin_valuat">
            <div class="valuat_title">估价（原币种）</div>
            <div class="list_contain">
                <div class="option-time">
                    <input
                        @focus="lowFocus"
                        @blur="lowBlur"
                        class="start-time"
                        :placeholder="low"
                        v-model="startGu"
                    />
                    <span>—</span>
                    <input
                        class="end-time"
                        @focus="bigFocus"
                        @blur="bigBlur"
                        :placeholder="big"
                        v-model="endGu"
                    />
                </div>
            </div>
        </div>

        <van-cell
            title="选择拍品类别"
            @click="category"
            :value="paipinlei"
            is-link
            url=""
        />
        <van-popup
            v-model="startdatatimeopen"
            position="bottom"
            :style="{ width: '100%'}"
        >
            <!-- 选择开始年月日 -->
            <van-datetime-picker
                class="datatime"
                v-model="currentstartDate"
                type="date"
                title="选择年月日"
                :min-date="minDate"
                :max-data="maxData"
                @confirm="startqueren"
                @cancel="startdatatimeopen = false"
            >
            </van-datetime-picker>
        </van-popup>
        <van-popup
            v-model="enddatatimeopen"
            position="bottom"
            :style="{ width: '100%'}"
        >
            <!-- 选择结束时间 -->
            <van-datetime-picker
                class="datatime"
                v-model="currentendDate"
                type="date"
                :min-date="currentstartDate ? currentstartDate : minDate"
                :max-date="maxData"
                title="选择年月日"
                @confirm="endqueren"
                @cancel="enddatatimeopen = false"
            >
            </van-datetime-picker>
        </van-popup>
        <!--  拍品类别弹出层 -->
        <van-popup
            v-model="cateshow"
            position="right"
            :style="{ width: '100%', height: '100%' }"
        >
            <van-nav-bar title="拍品类别" left-arrow @click-left="fink">
                <template #right>
                    <!-- <van-icon name="search" size="18" /> -->
                </template>
            </van-nav-bar>
            <div class="hot-search">
                <div class="hot-top">
                    <div class="hot-name">拍品类别</div>
                    <!-- <div class="hot-refresh" @click="rouate" ref="circle"></div> -->
                </div>
                <div class="hot-content">
                    <ul>
                        <li
                            ref="categoryDom"
                            @click="categorClick(item, index)"
                            :class="{'green':$route.query.params.classCode == item.classCode}"
                            v-for="(item, index) in artClassDatas"
                            :key="index"
                        >
                            {{ item.name }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="paipin_finsh">
                <div class="finish dis" v-if="disOk">完成</div>
                <div class="finish" @click="fink" v-else>完成</div>
            </div>
        </van-popup>

        <van-cell
            title="选择拍卖公司"
            @click="companyClick"
            :value="paimaigong"
            is-link
            url=""
        />

        <!-- 底部 -->
        <div class="footer">
            <div class="reset" @click="resest">重置</div>
            <div class="finish" @click="finishClick">完成</div>
        </div>
        <share :nunber="param.type"></share>
        <watermark v-if="showWater"></watermark>

    </div>
</template>

<script>
import {getTime, searchHi} from "@/api/auction";
import share from "./component/metaComponent.vue";
import watermark from "@/components/common/watermark";
import {Toast} from 'vant'
export default {
    data() {
        return {
            waterLink:'',
            showWater:false,
            paipinlei: "全部",
            paimaigong: "全部",
            // 拍品类别—+拍卖公司
            cateshow: false,
            comshow: false,
            selectList: {}, //热门城市的选中城市
            cityList: [],
            indexList: [
                "全部",
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "Z",
            ],
            dataList: [
                {
                    index: "A",
                    list: ["鞍山", "ajdkj"],
                },
                { index: "B", list: ["鞍山", "ajdkj"] },
                { index: "C", list: ["鞍山", "ajdkj"] },
                { index: "D", list: ["鞍山", "ajdkj"] },
                { index: "E", list: ["鞍山", "ajdkj"] },
                { index: "F", list: ["鞍山", "ajdkj"] },
                { index: "G", list: ["鞍山", "ajdkj"] },
                { index: "H", list: ["鞍山", "ajdkj"] },
                { index: "I", list: ["鞍山", "ajdkj"] },
                { index: "J", list: ["鞍山", "ajdkj"] },
                { index: "K", list: ["鞍山", "ajdkj"] },
                { index: "L", list: ["鞍山", "ajdkj"] },
                { index: "M", list: ["鞍山", "ajdkj"] },
                { index: "N", list: ["鞍山", "ajdkj"] },
                { index: "O", list: ["鞍山", "ajdkj"] },
                { index: "P", list: ["鞍山", "ajdkj"] },
                { index: "Q", list: ["鞍山", "ajdkj"] },
                { index: "R", list: ["鞍山", "ajdkj"] },
                { index: "S", list: ["鞍山", "ajdkj"] },
                { index: "T", list: ["鞍山", "ajdkj"] },
                { index: "U", list: ["鞍山", "ajdkj"] },
                { index: "V", list: ["鞍山", "ajdkj"] },
                { index: "W", list: ["鞍山", "ajdkj"] },
                { index: "X", list: ["鞍山", "ajdkj"] },
                { index: "Y", list: ["鞍山", "ajdkj"] },
                { index: "Z", list: ["鞍山", "ajdkj"] },
            ],
            // 估价的东西
            low: "最低价",
            big: "最高价",
            startGu: this.$route.query.params && this.$route.query.params.rmbPriceStart ? this.$route.query.params.rmbPriceStart : "",
            endGu: this.$route.query.params && this.$route.query.params.rmbPriceEnd ? this.$route.query.params.rmbPriceEnd : "",
            // 时间的东西
            startTitle: this.$route.query.params && this.$route.query.params.startdate ? this.$route.query.params.startdate : "拍卖开始日期",
            endTitle: this.$route.query.params && this.$route.query.params.enddate ? this.$route.query.params.enddate : "拍卖结束日期",
            cityparam: '', //城市参数
            currentstartDate: this.$route.query.params && this.$route.query.params.startdate ? this.$route.query.params.startdate : "",
            currentendDate: this.$route.query.params && this.$route.query.params.enddate ? this.$route.query.params.enddate : "",
            minDate:'',
            maxData:'',
            startdatatimeopen: false,
            enddatatimeopen: false,
            param: {
                status: null,
                startdate: "", //开始时间参数
                enddate: "", //结束时间参数
                rmbPriceStart: null, //开始估价
                rmbPriceEnd: null, //结束估价
                classCode: "", //拍品类别
                organCode: "", //公司
            },
            sosoList: {},
            searchStatusDatas: [], //拍卖状态
            artClassDatas: [], //拍品类别
            disOk:this.$route.query.params && this.$route.query.params.classCode ? false : true,
        };
    },
    created() {
        this.getsearchHi();
        if (this.$route.query.params) {
            this.param.status = this.$route.query.params.status;
            this.param.startdate = this.$route.query.params.startdate;
            this.param.enddate = this.$route.query.params.enddate;
            this.param.rmbPriceStart = this.$route.query.params.rmbPriceStart;
            this.param.rmbPriceEnd = this.$route.query.params.rmbPriceEnd;
            this.param.classCode = this.$route.query.params.classCode;
            this.param.organCode = this.$route.query.params.organCode;

        }
    },
    mounted(){
        if(this.$route.query.from){
            this.showWater = true
            this.waterLink = '&from='+this.$route.query.from
        }
        this.getTime()
    },
    //   导航栏的点击事件
    methods: {
        getTime(){
            getTime().then((res) => {
                if(res.code == 0){
                    let time = res.data.time_unix
                    this.currentstartDate = new Date(time*1000)
                    this.currentendDate = false
                    this.formatTime(time)
                }
            })
        },
        formatTime(t){
            let time = new Date(t*1000)
            this.minDate = new Date(time.getFullYear()-10,time.getMonth(),time.getDate());
            this.maxData = new Date(time.getFullYear()+10,time.getMonth(),time.getDate())
        },
        onClickLeft() {
            // 左按钮
            this.$router.back(-1);
        },
        // 开始时间确认按钮
        startqueren(value) {
            this.startdatatimeopen = false;
            // var datetime=value.getFullYear() + '-' + (value.getMonth() + 1) + '-' + value.getDate() + ' ' + value.getHours() + ':' + value.getMinutes() + ':' + value.getSeconds();
            // 时间格式化
            var datetime =
                value.getFullYear() +
                "-" +
                (value.getMonth() + 1) +
                "-" +
                value.getDate();
            this.startTitle = datetime;
            this.param.startdate = datetime;
        },
        // 结束时间确认按钮
        endqueren(value) {
            this.enddatatimeopen = false;
            // var datetime=value.getFullYear() + '-' + (value.getMonth() + 1) + '-' + value.getDate() + ' ' + value.getHours() + ':' + value.getMinutes() + ':' + value.getSeconds();
            //  时间格式化
            var datetime =
                value.getFullYear() +
                "-" +
                (value.getMonth() + 1) +
                "-" +
                value.getDate();
            this.endTitle = datetime;
            this.param.enddate = datetime;
        },
        // 开始时间点击事件
        startdatatime() {
            this.startdatatimeopen = !this.startdatatimeopen;
            // document.body.style.backgroundColor = "rgba(0,0,0,0.3)";
        },
        // 结束时间点击事件
        enddatatime() {
            this.enddatatimeopen = !this.enddatatimeopen;
            // document.body.style.backgroundColor = "rgba(0,0,0,0.3)";
        },

        // _++++++++++++++++++++++++++++++++++++++++++++++++++++估价方法
        // 最低价获取光标
        lowFocus() {
            this.low = "";
        },
        lowBlur() {
            this.low = "最低价";
            this.param.rmbPriceStart = this.startGu;
        },
        // 最高价获取光标
        bigFocus() {
            this.big = "";
        },
        bigBlur() {
            let that = this;
            this.big = "最高价";
            if(Number(this.startGu) > Number(this.endGu)){
                Toast({
                    message: '请输入正确最高价',
                    duration:2000,
                    onClose:function (){
                        that.endGu = ''
                    }
                })
            }else{
                this.param.rmbPriceEnd = this.endGu;
            }

        },

        // resest 重置
        resest() {
            this.param = {
                status: null,
                startdate: "", //开始时间参数
                enddate: "", //结束时间参数
                rmbPriceStart: null, //开始估价
                rmbPriceEnd: null, //结束估价
                classCode: "", //拍品类别
                organCode: "", //公司
            };
            this.startTitle = "拍卖开始日期";
            this.endTitle = "拍卖结束日期";
            this.startGu = "";
            this.endGu = "";
            this.low = "最低价";
            this.big = "最高价";
            this.paipinlei = "全部";
            this.paimaigong = "全部";
            this.artClassDatas.forEach((m, i) => {
                this.$refs.categoryDom[i].classList.remove("green");
            });
            this.searchStatusDatas.forEach((m, i) => {
                this.$refs.statusDom[i].classList.remove("statuss");
            });
        },
        // 完成按钮
        finishClick() {
            this.$router.push({
                name: "paipin",
                query: {
                    searchValue: this.$route.query.value,
                    params: this.param,
                    from:this.$route.query.from
                },
            });
        },
        // 拍品类别弹层
        category() {
            this.cateshow = true;
        },
        // 拍卖公司弹层
        companyClick() {
            this.$router.push({
                path:'/select/company',
                query:{
                    value:this.$route.query.value,
                    params:this.param,
                    from:this.$route.query.from
                }
            })
        },
        // 拍品类别弹层完成
        fink() {
            this.cateshow = false;
        },
        // 拍卖公司弹层完成
        chieve() {
            this.comshow = false;
        },
        // 拍品类别选择
        categorClick(item, index) {
            this.param.classCode = item.classCode;
            this.artClassDatas.forEach((m, i) => {
                if (i == index) {
                    this.paipinlei = m.name;
                    this.$refs.categoryDom[i].classList.add("green");
                } else {
                    this.$refs.categoryDom[i].classList.remove("green");
                }

                this.disOk = false
            });
        },
        // 拍卖状态
        statuClick(index) {
            this.searchStatusDatas.forEach((m, i) => {
                if (i == index) {
                    this.$refs.statusDom[i].classList.add("statuss");
                    this.param.status = m.id;
                } else {
                    this.$refs.statusDom[i].classList.remove("statuss");
                }
            });
        },
        // 调接口
        getsearchHi() {
            searchHi({ type: 2 }).then((res) => {
                if (res.code == 0) {
                    this.sosoList = res.data.artStatus;
                    // 拍卖状态
                    this.searchStatusDatas =
                        res.data.artStatus.searchStatusDatas;
                    // 拍卖类别
                    this.artClassDatas = res.data.artStatus.artClassDatas;

                    // 拍卖公司
                    this.comDatas = res.data.artStatus.comDatas;
                    this.indexList = ['全部']
                    for(let i=1;i<this.comDatas.length;i++){
                        this.indexList.push(this.comDatas[i].l)
                    }
                    if(this.$route.query.params){
                        this.artClassDatas.forEach((item)=>{
                            if(item.classCode == this.$route.query.params.classCode){
                                this.paipinlei = item.name
                            }
                        });
                        this.comDatas.forEach((item) => {
                            item.list.forEach((k) => {
                                if(k.organCode == this.$route.query.params.organCode){
                                    this.paimaigong = k.simpleName
                                }
                            })
                        })
                    }
                }
            });
        },
    },
    components: {
        share,
        watermark,
    },
};
</script>

<style scoped lang="scss">
// 顶部navbar样式
/deep/.van-nav-bar{
    line-height: 2.2rem;box-shadow:0rem 0.15rem 0.2rem 0rem rgba(0,0,0,.1);
    font-size: .9rem;
    .van-nav-bar__title{font-size: .9rem;color:#27282d;font-weight: normal;}
    .van-nav-bar__left{width:2.2rem;padding:0;justify-content: center;}
}
/deep/ .van-nav-bar .van-icon {
    color: #000000;
    font-size: 1.25rem;
}
/deep/ .van-popup {
    overflow-x: hidden;
    overflow-y: scroll;
}
.box {
    background-color: #ffffff;
}
.pin_state {
    padding: 0.5rem 0.75rem 0rem;
    .state_title {
        font-size: 0.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #27282d;
        line-height: 1.1rem;
    }
    .list_contain {
        display: flex;
        align-items: center;
        padding-top: 0.75rem;
        flex-wrap: wrap;
        .one {
            .one_item {
                margin: 0rem .5rem 0.5rem 0;
                background: #f7f7f7;
                line-height: 1.4rem;
                border-radius: 0.7rem;
                padding: 0 0.5rem;
            }
        }
    }
}
.statuss {
    .one_item {
        background: #e2f3eb !important;
        color: #18bd6f !important;
    }
}
// 拍卖时间
.pin_time {
    padding: 1rem 0.75rem 0rem;
    .time_title {
        font-size: 0.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #27282d;
        line-height: 1.1rem;
    }
    .list_contain {
        background-color: #ffffff;
        .option-time {
            width: 100%;
            height: 3.8rem;
            margin: 0 auto;
            background: #ffffff;
            display: flex;
            align-items: center;
        }
        .option-time .start-time,
        .option-time .end-time {
            width: 6.2rem;
            height: 1.8rem;
            background: #ffffff;
            border-radius: 0.2rem;
            border: 0.05rem solid #dddee3;
            font-size: 0.7rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #969696;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .option-time .start-time {
            //   margin-left: 1.8rem;
        }
        .option-time .end-time {
            //   margin-right: 2.9rem;
        }
        .option-time span {
            font-size: 0.7rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            margin:0 1rem;
            color: #969696;
        }
    }
}
.pin_valuat {
    padding: 0.5rem 0.75rem 0rem;
    .valuat_title {
        font-size: 0.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #27282d;
        line-height: 1.1rem;
    }
    .list_contain {
        background-color: #ffffff;
        .option-time {
            width: 100%;
            height: 3.8rem;
            margin: 0 auto;
            background: #ffffff;
            display: flex;
            align-items: center;
        }
        .option-time .start-time,
        .option-time .end-time {
            width: 6.2rem;
            height: 1.8rem;
            background: #ffffff;
            border-radius: 0.2rem;
            border: 0.05rem solid #dddee3;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.7rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #969696;
            text-align: center;
        }
        .option-time .start-time {
            //   margin-left: 1.8rem;
        }
        .option-time .end-time {
            //   margin-right: 2.9rem;
        }
        .option-time span {
            font-size: 0.7rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #969696;
            margin:0 1rem;
        }
    }
}

// 拍品类别
/deep/ .van-cell__title {
    font-size: 0.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
}
/deep/ .van-cell__value {
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}
.green {
    color: green;
}
.paipin_finsh {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 18.75rem;
    margin: 0 auto;
    height: 3rem;
    background: #ffffff;
    box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
    display: flex;
    padding: 0 0.75rem;
    align-items: center;
    justify-content: space-between;
    z-index: 999;
    .finish {
        width: 100%;
        height: 2.2rem;
        background: #18bd6f;
        box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
        border-radius: 0.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 1.1rem;
        text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
    }
    .dis{background-color: #BBBBBB;}
}
// 拍品类别
.hot-search {
    width: 18.75rem;
    // height: 6.25rem;
    background: #ffffff;
    padding: 0.75rem 0.75rem;
    margin-bottom: 0.25rem;
}
.hot-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.hot-top .hot-name {
    height: 1.1rem;
    font-size: 0.8rem;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #27282d;
    line-height: 1.1rem;
}
.hot-search .hot-content {
    margin-top: 0.8rem;
}
.hot-search .hot-content ul {
    overflow: hidden;
}
.hot-content li {
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    line-height: 1.05rem;
    padding: 0.2rem 0.5rem;
    height: 1.35rem;

    background: #f7f7f7;
    border-radius: 0.7rem;
    //   border: 0.03rem solid #b8b8b8;
    text-align: center;
    float: left;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
}
.green {
    // background-color: #18BD6F!important;
    background: #e2f3eb !important;
    color: #18bd6f !important;
}

/* 底部 */
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 18.75rem;
    margin: 0 auto;
    height: 3rem;
    background: #ffffff;
    box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
    display: flex;
    padding: 0 0.75rem;
    align-items: center;
    justify-content: space-between;
}
.footer .reset {
    width: 5.2rem;
    height: 2.2rem;
    background: #FFFFFF;
    border-radius: 0.2rem;
    border: 0.05rem solid #DDDEE3;
    font-size: .8rem;
    color:#27282d;
    display:flex;
    justify-content: center;
    align-items: center;
}
.footer .finish {
    width: 11.5rem;
    height: 2.2rem;
    background: #18bd6f;
    box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
    border-radius: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 1.1rem;
    text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}
.footer .finish.dis{color: #BBBBBB;}
</style>